<template>
  <el-row class="index-main">
    <div>
      <el-row class="yujing">
        <el-row>
          <span style="font-size: 20px; color: #888888">预警提醒</span>
        </el-row>
        <el-row style="margin-top: 35px">
          <ul class="my-ul">
            <!-- 收到的竞价单-竞价-待报价 -->
            <li
              class="center hand"
              @click="
                toUrl(
                  '/goods/get-rush-bidding-list?status=AwaitOffer',
                  'QIANGDANJINGJIABIAO_WOSHOUDAODE'
                )
              "
            >
              <el-row class="round red">{{ quote_bidding }}</el-row>
              <el-row class="mt-15">待报价（单）</el-row>
            </li>
            <!-- 抢单竞价表我发出的--竞价-进行中 -->
            <li
              class="center hand"
              @click="
                toUrl(
                  '/goods/send-rush-bidding-list?status=PROCEED',
                  'QIANGDANJINGJIABIAO_WOFACHUDE'
                )
              "
            >
              <el-row class="round blue">{{ bidding }}</el-row>
              <el-row class="mt-15">待确价（单）</el-row>
            </li>
            <!-- <li class="center hand" @click="toUrl('/goods/entrust-carrier-list','WOYAODIAODU_SHOUDAOWEITUODAN')">
              <el-row class="round yellow">{{send_sum}}</el-row>
              <el-row class="mt-15">待派车（吨）</el-row>
            </li> -->
            <!-- 运单列表：支付完成，定位失败，回单已传 -->
            <li
              class="center hand"
              @click="
                toUrl(
                  '/waybill/waybill-list?pay_status=PaymentEnd&position_status=PositionFailure&receipt_status=UN_LOAD',
                  'YUNDANGENZONG_YUNDANLIEBIAO'
                )
              "
            >
              <el-row class="round perpur">{{ location_anomaly }}</el-row>
              <el-row class="mt-15">追踪异常（单）</el-row>
            </li>

            <!-- 财务管理---运费支付--运单支付页面 -->
            <li
              class="center hand"
              @click="
                toUrl(
                  '/settle/waybill-pay-list?num=0',
                  'CAIWUGUANLI_YUNFEIZHIFU'
                )
              "
            >
              <el-row class="round green">{{ freight }}</el-row>
              <el-row class="mt-15">待支付运费（元）</el-row>
            </li>
            <!-- 财务管理---申请开票--物流辅助费支付页面 -->
            <li
              class="center hand"
              @click="
                toUrl(
                  '/settle/waybill-pay-list?num=1',
                  'CAIWUGUANLI_YUNFEIZHIFU'
                )
              "
            >
              <el-row class="round green">{{ assistance_fee }}</el-row>
              <el-row class="mt-15">待支付辅助费（元）</el-row>
            </li>
            <li
              class="center hand"
              @click="
                toUrl(
                  '/settle/ticket-apply-list',
                  'CAIWUGUANLI_SHENQINGKAIPIAO'
                )
              "
            >
              <el-row class="round blue">{{ assistance_fee }}</el-row>
              <el-row class="mt-15">待开票（元）</el-row>
            </li>
          </ul>
        </el-row>
      </el-row>
      <el-row class="box main-bd">
        <el-row class="list-title clearfix">
          <ul class="list-nav fl clearfix">
            <li :class="active" @click="zhipai">指 派（{{ data.entrust }}）</li>
            <li :class="active1" @click="qiangdan">
              抢单竞价生成（{{ data.bid_or_rob }}）
            </li>
          </ul>
        </el-row>
        <span
          class="mainColor hand"
          style="position: absolute; top: 40px; right: 30px"
          @click="toUrl('/goods/entrust-carrier-list')"
        >
          更多委托单 >
        </span>
        <el-row style="margin-bottom: 5px">
          <span class="grayColor">
            委托总量：
            <!-- <em class="mainColor">{{data.goods_total}}</em> 吨 -->
            <em
              class="mainColor mr-5"
              v-for="(item, index) in data.goods_total_list"
              :key="index"
              >{{ item.weight_count }} {{ item.metering_unit }},</em
            >
          </span>
          <span class="grayColor" style="margin-left: 20px">
            承运总量：
            <!-- <em class="mainColor">{{data.carrying_amount}}</em> 吨 -->
            <em
              class="mainColor mr-5"
              v-for="(item, index) in data.carrying_amount_list"
              :key="index"
              >{{ item.weight_count }} {{ item.metering_unit }},</em
            >
          </span>
          <span class="grayColor" style="margin-left: 20px">
            库存总量：
            <!-- <em class="mainColor">{{data.inventory_amount}}</em> 吨 -->
            <em
              class="mainColor mr-5"
              v-for="(item, index) in data.inventory_amount_list"
              :key="index"
              >{{ item.weight_count }} {{ item.metering_unit }},</em
            >
          </span>
        </el-row>
        <el-table
          class="nth"
          :empty-text="empty_text"
          border
          ref="multipleTable"
          :data="data.content"
          style="width: 100%"
        >
          <el-table-column min-width="130" label="委托单号">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="20">
                  <p v-if="showCode">{{ scope.row.code }}</p>
                  <span
                    @click="
                      toUrl(
                        '/goods/entrust-carrier-details?pid=' +
                          scope.row.pid +
                          '&num=' +
                          scope.row.num,
                        'WOYAODIAODU_SHOUDAOWEITUODAN_WEITUODANXIANGQING'
                      )
                    "
                    type="text"
                    class="link mainColor"
                    >{{ scope.row.entrust_code }}</span
                  >
                  <p v-if="scope.row.commission_id !== null">
                    欧冶委托单号：{{ scope.row.commission_id }}
                  </p>
                </el-col>
                <el-col :span="4">
                  <i
                    class="mark"
                    style="background: blue; float: right"
                    v-if="
                      scope.row.entrust_state == 'EntirelyWaybill' ||
                      scope.row.entrust_state == 'PortionWaybill'
                    "
                    >派</i
                  >
                  <i
                    class="mark"
                    style="background: #67c23a"
                    v-if="scope.row.entrust_state == 'Bidding'"
                    >竞</i
                  >
                  <i
                    class="mark"
                    style="background: green"
                    v-if="scope.row.entrust_state == 'Entrust'"
                    >分</i
                  >
                  <!-- <i class="mark" style="background:#cc0816" v-if="scope.row.entrust_state=='IntermodalTransport'">联</i> -->
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column
            prop="entrusting_per"
            label="委托方"
          ></el-table-column>
          <el-table-column min-width="150" label="线路">
            <template slot-scope="scope">
              <ul>
                <li>
                  <i class="iconfont icon-icon48 mainColor"></i>
                  {{ scope.row.loading_address_province }}/{{
                    scope.row.loading_address_city
                  }}/{{ scope.row.loading_address_area }}
                </li>
                <li>
                  <i class="iconfont icon-icon48 green"></i>
                  {{ scope.row.unloading_address_province }}/{{
                    scope.row.unloading_address_city
                  }}/{{ scope.row.unloading_address_area }}
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="goods_total" label="委托量"></el-table-column>
          <el-table-column
            prop="carrying_amount"
            label="承运量"
          ></el-table-column>
          <el-table-column
            prop="inventory_amount"
            label="库存量"
          ></el-table-column>
          <el-table-column
            prop="valuation_type_text"
            label="计价方式"
            min-width="65"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            label="创建日期"
            min-width="120"
          ></el-table-column>
          <el-table-column align="center" label="操作" min-width="130">
            <template slot-scope="scope">
              <el-row>
                <!-- :disabled="scope.row.entrustButton" -->
                <el-button
                  v-if="scope.row.appoint"
                  @click="toUrl('/goods/bidding-send?pid=' + scope.row.pid)"
                  type="text"
                  >生成竞价单</el-button
                >
                <el-button
                  v-if="scope.row.sendCar"
                  type="text"
                  @click="toUrl('/car/car-send?pid=' + scope.row.pid)"
                  >派车</el-button
                >
                <!-- <el-button v-if="scope.row.IntermodalTransport" type="text" @click="transport(scope.row.pid)" disabled>联运</el-button> -->
                <!-- 节点更新 -->
                <el-button
                  v-if="scope.row.commission_id && scope.row.dispatch_id"
                  type="text"
                  @click="
                    transfer(scope.row.commission_id, scope.row.dispatch_id)
                  "
                  >转单</el-button
                >
              </el-row>
              <el-row>
                <el-button
                  v-if="scope.row.appoint"
                  @click="
                    toUrl(
                      '/goods/entrust-send?pid=' +
                        scope.row.pid +
                        '&num=' +
                        scope.row.num
                    )
                  "
                  type="text"
                  >指定承运方</el-button
                >
                <el-button
                  v-if="
                    !scope.row.sync_platform == 'ZC' ||
                    (scope.row.cancel && scope.row.sync_platform != 'ZC')
                  "
                  type="text"
                  @click="cancel(scope.row.pid)"
                  >取消</el-button
                >
                <el-button
                  v-if="scope.row.see"
                  type="text"
                  @click="see(scope.row.pid)"
                  >查看</el-button
                >
                <span v-if="scope.row.cancelTransport">已取消运输</span>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-button
        type="primary"
        round
        class="baojiaBtn0"
        @click="toUrl('/ofer/ofer-list')"
        v-if="showOfer"
        >天天报价</el-button
      >
      <el-button
        type="primary"
        round
        class="baojiaBtn"
        @click="toUrl('/ofer/enquiry-list')"
        v-if="showOfer"
        >一键询价</el-button
      >
    </div>
  </el-row>
</template>
<script>
import { isSuccess } from "@/assets/js/utils";
export default {
  data() {
    return {
      data: {
        content: [],
      },
      active: "active",
      active1: "",
      showCode: false, //竞价单号是否显示
      empty_text: "数据更新中，请稍后",
      search: {
        value2: "",
        entrusting_per: "",
        entrust_shipper_state: "all",
        entrust_code: "",
        create_time_begin: "",
        create_time_finish: "",
        type: 1,
        paging: {
          page_size: 10,
          total: 0,
          pages: 0,
          page_num: 1,
        },
      },
      quote_bidding: null,
      bidding: null,
      send_sum: null,
      location_anomaly: null,
      assistance_fee: null,
      await_pay: null,
      invoice_amount: null,
      freight: null,
      assistance_fee: null,
      showOfer: false,
    };
  },
  mounted() {
    if (_global_.LOGIN_INFO.parent_dep_codes.indexOf("DELEGATE") !== -1) {
      this.showOfer = true;
    } else {
      this.showOfer = false;
    }
    console.log(
      this.showOfer,
      _global_.LOGIN_INFO.parent_dep_codes.indexOf("DELEGATE")
    );
    this.loadList();
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path == "/") {
          this.loadList();
        }
      },
      deep: true,
    },
  },
  methods: {
    //节点更新
    transfer(commission_id, dispatch_id) {
      if (confirm("确认更新转单节点？")) {
        this.rr.commission_id = commission_id;
        this.rr.dispatch_id = dispatch_id;
        //弹窗确定是否操作
        api("entrust.transfer", this.rr).then((res) => {
          alert(res.msg);
        });
      }
    },
    //取消
    cancel(pid) {
      if (confirm("确认取消？")) {
        api("entrust.receive.cancel.entrust.update", { id: pid }).then(
          (res) => {
            let data;
            if ((data = isSuccess(res))) {
            }
            alert(res.msg);
            this.loadList();
          }
        );
      }
    },
    see(pid) {
      //查看
      api("entrust.examine.query", { id: pid }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          if (data.entrust_state == "Entrust") {
            toUrl("/goods/entrust-client-details?pid=" + data.id);
          } else if (data.entrust_state == "Bidding") {
            toUrl("/goods/bidding-client-details?pid=" + data.id);
          } else {
            toUrl("/goods/entrust-carrier-details?pid=" + pid);
          }
        }
      });
    },
    loadList() {
      // 待报价
      api("indexsum.not.quote.bidding.sum").then((res) => {
        let data = isSuccess(res);
        this.quote_bidding = data;
      });
      // 待确价
      api("indexsum.confirm.bidding.sum").then((res) => {
        let data = isSuccess(res);
        this.bidding = data;
      });

      // api("indexsum.take.send.sum").then(res => {
      //   let data = isSuccess(res);
      //   this.send_sum = Math.floor(data);
      // })
      // 追踪异常
      api("indexsum.waybill.location.anomaly").then((res) => {
        let data = isSuccess(res);
        this.location_anomaly = data;
      });
      // api('indexsum.unclosed.waybill.weight').then(res => {
      //   let data = isSuccess(res)
      //   this.unclosed_weight = Math.floor(data);
      // })
      // 待支付运费
      api("waybill.sum.payable.amount", { payment_status: "AwaitPay" }).then(
        (res) => {
          let data = isSuccess(res);
          this.freight = Math.floor(data.payable_amount + data.service_amount);
        }
      );
      // 待支付物流辅助费
      api("indexsum.waybill.subsidiary.sum").then((res) => {
        let data = isSuccess(res);
        this.assistance_fee = Math.floor(data);
      });
      // api('indexsum.await.pay.waybill').then(res => {
      //   let data = isSuccess(res)
      //   this.await_pay = Math.floor(data);
      // })
      // api('indexsum.not.invoice.amount.sum').then(res => {
      //   let data = isSuccess(res)
      //   this.invoice_amount = Math.floor(data);
      // })
      // this.search = getCache(this.search);
      this.search.paging.page_size = 1000000;
      api("entrust.receive.entrust.query", this.search).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.data = data;
          this.data.content = data.receive_entrust_list.slice(0, 9);
          if (this.data.content.length == 0) {
            this.empty_text = "暂无数据";
          }
          this.search.paging.total = res.data_total;
          if (this.search.type == 2) {
            this.showCode = true;
          } else {
            this.showCode = false;
          }
          //生成竞价单按钮显示条件
          this.data.content = this.data.content.map((item) => {
            item.num = 0;
            // if (item.entrust_state == "Created") {
            //   item.entrustButton = true;
            // } else {
            //   item.entrustButton = false;
            // }
            if (item.entrust_state == "Created" && item.bid_num == 1) {
              item.appoint = true;
            } else {
              item.appoint = false;
            }
            if (item.entrust_state == "Created") {
              //待反馈
              // item.appoint = true;
              item.sendCar = true;
              item.cancel = true;
              item.see = false;
              item.cancelTransport = false;
            } else if (item.entrust_state == "Refused") {
              //已拒单
              item.appoint = false;
              item.sendCar = false;
              item.cancel = false;
              item.see = false;
              item.cancelTransport = true;
            } else if (
              item.entrust_state == "EntirelyWaybill" ||
              item.entrust_state == "Bidding" ||
              item.entrust_state == "Entrust" ||
              item.entrust_state == "IntermodalTransport"
            ) {
              //已处理
              item.appoint = false;
              item.sendCar = false;
              item.cancel = false;
              item.see = true;
              item.cancelTransport = false;
            } else if (item.entrust_state == "Completed") {
              //已完成
              item.appoint = false;
              item.sendCar = false;
              item.cancel = false;
              item.see = true;
              item.cancelTransport = false;
            } else if (item.entrust_state == "PortionWaybill") {
              //部分派单
              item.appoint = false;
              item.sendCar = true;
              item.cancel = false;
              item.see = false;
              item.cancelTransport = false;
            }
            return item;
          });
        }
      });
    },
    zhipai() {
      this.search.type = 1;
      this.active = "active";
      this.active1 = "";
      this.loadList();
    },
    qiangdan() {
      this.search.type = 2;
      this.active = "";
      this.active1 = "active";
      this.loadList();
    },
  },
};
</script>
<style scoped lang="scss">
.yingluimg {
  background: url("../assets/images/yinlupng.png") no-repeat 100%;
}
.baojiaBtn {
  position: absolute;
  top: 55%;
  right: -10%;
  height: 38px;
}
.baojiaBtn0 {
  position: absolute;
  top: 50%;
  right: -10%;
  height: 38px;
}
.my-sum {
  position: absolute;
  top: 41px;
  left: 30%;
}
.list-title {
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 20px;
}
.list-nav {
  border: 1px solid #e5e5e5;
  border-bottom: none;
  margin-right: 10px;
}
.list-nav li {
  float: left;
  width: 170px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  background: #f9f9f9;
  cursor: pointer;
}
.list-nav li.active {
  color: #fff;
  background: #cc0816;
}
.list-nav li:hover {
  color: #fff;
  background: #cc0816;
}
.yujing {
  height: 260px;
  background: #fff;
  margin-bottom: 30px;
  padding: 30px;
}
.center {
  text-align: center;
  float: left;
  // margin-right: 6.3%;
}
.my-ul {
  display: flex;
  justify-content: space-around;
}
.mr-5 {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue